import { render, staticRenderFns } from "./coupon-scan.vue?vue&type=template&id=623fa09e&scoped=true&"
import script from "./coupon-scan.vue?vue&type=script&lang=js&"
export * from "./coupon-scan.vue?vue&type=script&lang=js&"
import style0 from "./coupon-scan.vue?vue&type=style&index=0&id=623fa09e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623fa09e",
  null
  
)

export default component.exports